// https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a

/*****************************************
 * * IMPORTS
 *****************************************/

// React libraries
import React, { PureComponent } from 'react';
import Chart from 'chart.js';

// styles and images
import styles from './ChartCanvas.module.css';

// external data
import { options } from './options';

// components

/*****************************************
 * * CHART OPTIONS
 *****************************************/

// place global options above the class
Chart.defaults.global.responsive = true;
// Chart.defaults.global.defaultFontFamily = 'Alef, sans-serif';
Chart.defaults.global.legend.display = true;
// Setting the tension to 0 removes the smooth curves in our graph.
// Optionally, you can set the value to 0.1 or 0.2 to get a slight tension curve.
Chart.defaults.global.elements.line.tension = 0;

/*****************************************
 * * CREATE COMPONENT
 *****************************************/
// Using regular component, the component  re-renders even
// when irrelevant state changes in the parent component.
// In addition, the chart’s load animation will fire when
// no change to the chart has occurred.
// PureComponent solves this.
// from React docs:
// If your React component’s render() function renders the same
// result given the same props and state, you can use
// React.PureComponent for a performance boost in some cases.
// look also in
// https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a
class ChartCanvas extends PureComponent {
  canvasRef = React.createRef();

  componentDidUpdate() {
    this.myChart.data.labels = this.props.data.xLabels;
    // two graphs - y values
    this.myChart.data.datasets[0].data = this.props.data.values.speed;
    this.myChart.data.datasets[1].data = this.props.data.values.pid;

    this.myChart.update();
  }

  // after component is rendered
  componentDidMount() {
    let canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');

    // real box widthxheight
    // default 300x150
    // canvas.width = this.props.size.width;
    // canvas.height = this.props.size.height;

    // check if was already defined. is not required here
    // since we use update and not recreate the chart
    // again and again.
    // but is good for general case
    if (typeof this.myChart !== 'undefined') {
      this.myChart.destroy();
    }
    this.myChart = new Chart(ctx, {
      // The type of chart we want to create
      // responsive: true,
      type: 'line',
      // The data for our dataset
      data: {
        labels: this.props.data.xLabels,
        datasets: [
          {
            label: this.props.data.legendLabels[0],
            data: this.props.data.values.speed,
            backgroundColor: 'navy',
            borderColor: 'navy',
            lineTension: 0,
            fill: false,
            borderWidth: 1,
            pointBackgroundColor: 'navy',
            pointBorderWidth: 1,
            pointRadius: 1,
            // pointHoverRadius: 10,
            // pointHoverBackgroundColor: 'white',
            // pointHoverBorderColor: 'gray',
            // pointHoverBorderWidth: 8,
          },
          {
            label: this.props.data.legendLabels[1],
            data: this.props.data.values.pid,
            backgroundColor: 'rgba(0, 161, 180, 0.23)',
            borderColor: 'rgba(0, 161, 180, 1)',
            lineTension: 0, // 0 - line, other - bezier
            fill: true,
            borderWidth: 1,

            pointBackgroundColor: 'white',
            pointBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 0,
            spanGaps: true,
          },
        ],
      },
      // Configuration options go here
      options: options,
    });
  }

  render() {
    return (
      <div className={styles.chart}>
        {/* chart title */}
        {/* <div className={styles.heading}>{this.props.title}</div> */}

        {this.props.children}

        {/* chart */}
        <canvas ref={this.canvasRef} className={styles.frame} />
      </div>
    );
  }
}

export default ChartCanvas;
